import { useState } from "react";
import { ChevronDown, Users } from "lucide-react";
import { KEPEGAWAIAN_GROUPS } from "@/data/kepegawaianData";

// Dropdown daftar pegawai per Tim Kerja pada halaman "Data Pegawai".
function GroupItem({ slug, label, names }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      data-testid={`pegawai-item-${slug}`}
      className="overflow-hidden rounded-2xl border border-[#BBDCF3] bg-white"
    >
      <button
        type="button"
        data-testid={`pegawai-toggle-${slug}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-[#F4FAFE]"
      >
        <span className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EFF6FC]">
            <Users aria-hidden="true" className="h-5 w-5 text-[#1479BF]" />
          </span>
          <span className="font-display text-base font-semibold md:text-lg">
            {label}
          </span>
        </span>
        <span className="flex items-center gap-3">
          <span className="rounded-full bg-[#EFF6FC] px-2.5 py-0.5 text-xs font-semibold text-[#1479BF]">
            {names.length}
          </span>
          <ChevronDown
            aria-hidden="true"
            className={`h-5 w-5 shrink-0 text-[#1479BF] transition-transform duration-300 ${
              open ? "rotate-180" : ""
            }`}
          />
        </span>
      </button>

      {open && (
        <div
          data-testid={`pegawai-body-${slug}`}
          className="border-t border-[#E3F0FA] bg-[#FBFDFF] px-5 py-4"
        >
          <ol className="space-y-1.5">
            {names.map((name, i) => (
              <li
                key={`${slug}-${i}`}
                className="flex items-start gap-3 text-[13px] leading-relaxed text-slate-700 md:text-sm"
              >
                <span className="min-w-[1.75rem] shrink-0 text-right font-semibold tabular-nums text-[#1479BF]">
                  {i + 1}.
                </span>
                <span>{name}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}

export default function KepegawaianSection() {
  return (
    <div data-testid="pegawai-section" className="mt-10 space-y-3">
      {KEPEGAWAIAN_GROUPS.map((g) => (
        <GroupItem key={g.slug} {...g} />
      ))}
    </div>
  );
}
